import React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import PropTypes from 'prop-types';

const buttonCss =
    'px-4 bg-green-700 hover:bg-green-800 mx-4 font-semibold rounded focus:outline-none';
const disabledButtonCss =
    'px-4 bg-green-700 mx-4 font-semibold rounded opacity-50  cursor-not-allowed';

const ControlButtons = ({
    nextHandler,
    prevHandler,
    currentSlide,
    maxSkippableSlides,
    totalSlide,
}) => (
    <div className="text-sm md:text-lg w-full flex justify-center bg-black text-white font-semibold py-1">
        <button
            className={currentSlide <= 1 ? disabledButtonCss : buttonCss}
            onClick={prevHandler}
            disabled={currentSlide <= 1}
            type="button"
            data-testid="previous-slide"
        >
            <span className="hidden md:inline-block align-middle md:pr-2 text-base pb-1">
                {' '}
                <FaArrowLeft />{' '}
            </span>{' '}
            Previous Slide{' '}
        </button>

        <span className="py-1 text-center" data-testid="slide-counter">
            {' '}
            slide {currentSlide} of {totalSlide}{' '}
        </span>
        <button
            className={
                currentSlide >= maxSkippableSlides
                    ? disabledButtonCss
                    : buttonCss
            }
            onClick={nextHandler}
            disabled={currentSlide >= maxSkippableSlides}
            type="button"
            data-testid="next-slide"
        >
            Next Slide{' '}
            <span className="hidden md:inline-block align-middle md:pl-2 text-base pb-1">
                {' '}
                <FaArrowRight />{' '}
            </span>
        </button>
    </div>
);

ControlButtons.propTypes = {
    nextHandler: PropTypes.func,
    prevHandler: PropTypes.func,
    currentSlide: PropTypes.number,
    maxSkippableSlides: PropTypes.number,
    totalSlide: PropTypes.number,
};

export default ControlButtons;
